// Used both as the cookie name and as the URL search param that seeds it - a coupon code smuggled
// into a link this way gets applied to the cart without ever showing up in the visible URL.
export const stealthPromoCookieName = "stealthPromo";
